import { render, staticRenderFns } from "./LeadersMobile.vue?vue&type=template&id=020c367e&scoped=true&"
import script from "./LeadersMobile.vue?vue&type=script&lang=js&"
export * from "./LeadersMobile.vue?vue&type=script&lang=js&"
import style0 from "./LeadersMobile.vue?vue&type=style&index=0&id=020c367e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c367e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VRow})
